import React, { useState } from 'react'
import { Form, Formik } from 'formik'
import axios from "axios";
import clsx from 'clsx'
import {
  Button,
  Container,
  TextField,
  Typography
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import {injectIntl} from "react-intl";

import PopupModal from "../../common/elements/PopupModal";
import styles from './styles'
import messages from "./messages";

const initialValues = { email: '' };

const ResetPasswordForm = props => {
  const {
    classes,
    intl: { formatMessage },
  } = props
  const [sentEmailMessage, setSentEmailMessage] = useState('')
  const [removeErrorTitle, setRemoveErrorTitle] = useState(false)

  const sendResetPasswordEmail = values => {
    const { email } = values

    axios.post('/api/v2/users/reset_password', {
      username: email,
      send_channel: 'email'
    })
      .then(() => {
        setRemoveErrorTitle(true)
        setSentEmailMessage(formatMessage(messages.validEmailMessage, { email }), )
      })
      .catch(() => setSentEmailMessage(formatMessage(messages.failedEmailMessage, { email })))
  }

  const closePopupModal = () => {
    setRemoveErrorTitle(false)
    setSentEmailMessage('')
  }

  return (
      <Formik initialValues={initialValues} onSubmit={sendResetPasswordEmail}>
        {({values, handleChange}) => (
          <Form>
            <Container className={classes.formContainer}>
              <Typography className={classes.displayMessage}>{formatMessage(messages.resetPassword)}</Typography>
              <TextField
                className={clsx(classes.textFields, classes.marginTop60)}
                label={formatMessage(messages.email)}
                name='email'
                type='email'
                onChange={handleChange}
              />
              <PopupModal
                className={classes.modalPlacement}
                message={sentEmailMessage}
                open={!!sentEmailMessage}
                removeErrorTitle={removeErrorTitle}
                onClose={closePopupModal}
              />
            </Container>
            <Button
              className={clsx(classes.majorButton, classes.marginTop30)}
              disabled={!values.email}
              color='primary'
              variant='contained'
              type='submit'
            >
              {formatMessage(messages.sendEmail)}
            </Button>
          </Form>
        )}
    </Formik>
  )
}

export default withStyles(styles)(injectIntl(ResetPasswordForm))
